import p from './not-found.vue';

export default p;
